import React from 'react'
import styled from 'styled-components'

import { NumberInput } from '../../../../input'
import { FONTS } from '../../../../../constants'

export const ManDayRow = React.memo(({
  data,
  index,
  isEditing,
  progressIndex,
  handleInput,
}) => {
  const man_day_rate = (data && data._man_day_rate) || 0

  return (
    <Root>
      <FormWrapper>
        <Label>Manday-rate</Label>
        <NumberInput
          placeholder='Enter Manday-rate'
          allowEmptyFormatting={ true }
          thousandSeparator={ true }
          decimalScale={ 2 }
          fixedDecimalScale={ true }
          disabled={ !isEditing }
          value={ man_day_rate }
          onChange={ e => handleInput(e.target.value, progressIndex, index, 'man_day_rate') }
        />
      </FormWrapper>
      <FormWrapper />
      <FormWrapper />
    </Root>
  )
})

const Root = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  :nth-child(1) {
      padding-right: 6px;
  }

  :nth-last-child(1) {
      padding-left: 6px;
  }
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #808080;

  ${p => p.required && `
    ::after {
      content: '*';
      color: red;
    }
  `}
`



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/item/detail/ManDayRow.js